import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
export const CommandBarContext = createContext(undefined);
export const CommandBarProvider = ({ children }) => {
    const [context, setContext] = useState({
        entity: null,
        entityType: 'network',
    });
    const [options, setOptions] = useState({});
    const [isOpen, setOpen] = useState(false);
    const value = useMemo(() => {
        return {
            context,
            setContext,
            isOpen,
            open: options => {
                setOptions(options !== null && options !== void 0 ? options : {});
                setOpen(true);
            },
            close: () => {
                setOptions({});
                setOpen(false);
            },
            options,
        };
    }, [context, isOpen, options]);
    return (_jsx(CommandBarContext.Provider, { value: value, children: children }, void 0));
};
export function useCommandBar() {
    const context = useContext(CommandBarContext);
    if (context === undefined) {
        throw new Error('useCommandBarContext must be used within a CommandBarProvider');
    }
    return context;
}
//# sourceMappingURL=CommandBarContext.js.map